import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { KeywordService } from '../../../services/keyword.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'fw-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [ReactiveFormsModule, NgIf]
})
export class SearchComponent implements OnInit {

  public option;
  public options;
  public searchForm: UntypedFormGroup;
  public loading = false;
  public labelVisible = true;

  constructor(private formBuilder: UntypedFormBuilder, private keywordSrv: KeywordService, private router: Router) { }

  public onOptionSelected($event) {
    this.router.navigate(['keyword', $event.option.value.id]);
    this.options = [];
    this.searchForm.get('searchInput').setValue('');
  }

  onClearForm() {
    this.searchForm.get('searchInput').setValue('');
    this.labelVisible = true;
    this.keywordSrv.searchResults.next([]);
    this.loading = false;
  }

  ngOnInit() {
    this.searchForm = this.formBuilder.group({
      searchInput: null
    });

    this.router.events.subscribe(() => {
      this.searchForm.get('searchInput').setValue('');
    });

    this.searchForm.get('searchInput').valueChanges.subscribe((q: string) => {
      this.labelVisible = q.length === 0;
      if (q.length >= 3) {
        this.loading = true;
        this.keywordSrv.search(q, 1).subscribe((keywords) => {
          this.loading = false;
          this.options = keywords;
          this.keywordSrv.searchResults.next(this.options);
        });
      }
      if (q.length === 0) {
        this.keywordSrv.searchResults.next([]);
        this.loading = false;
      }
    });
  }

}
